import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  secondaryWrapper: {
    position: 'relative',
    left: 0,
  },
  secondaryCards: {
    padding: 24,
    margin: '16px 0',
  },
  textRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
  },
  iconCalendar: {
    color: theme.palette.secondary.main,
    marginRight: 12,
  },
  textRowSecondary: {
    marginLeft: 10,
    fontWeight: 400,
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  logoWrapper: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
  },
  logo: {
    width: '100%',
    maxHeight: 80,
    objectFit: 'contain',
  },
  logoContainer: {
    maxWidth: 200,
    height: 'auto',
    flex: 1,
  },
  loadingWrapper: {
    height: 'auto',
  },
  line: {
    width: '100%',
    height: 1,
    background: theme.palette.secondary.light,
    margin: '16px 0',
  },
  section: {
    width: '100%',
    marginTop: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  fourColumnGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto auto',
    gap: '16px 0px',
    gridTemplateAreas: '". ."". ."',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  icon: {
    color: theme.palette.secondary.dark,
  },
  iconLabel: {
    marginLeft: 8,
    color: theme.palette.common.black,
    fontWeight: 400,
  },
  description: {
    color: theme.palette.common.black,
    marginLeft: 12,
    fontWeight: 400,
  },
  dateInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  body3: {
    marginLeft: 11,
    fontWeight: 400,
  },
}))

export default useStyles
